import "./Footer.css";

export default function Footer() {
    return (
        <div className="Footer-container">
            <div className="Footer-developer">
                <a href="https://github.com/keenlyhere" target="_blank">
                    <i className="fa-brands fa-github"></i>
                </a>
                <a href="https://www.linkedin.com/in/keenly-chung-b10485257/" target="_blank">
                    <i className="fa-brands fa-linkedin"></i>
                </a>
                © Keenly Chung 2023
            </div>
            <p>Task icons by <a href="https://icon-icons.com/users/jU68e8AK4V9vJWDuIDOsp/icon-sets/" target="_blank">Sergei Kokota</a></p>
        </div>
    )
}
